import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { SidebarElementType, SidebarTitleType } from '../../types';
import { AccordionDetailtem } from './AccordionDetailtem';
import { ArrowDownIcon } from 'src/assets/icons/common/ArrowDownIcon';

type Props = {
  title: SidebarTitleType;
  elements: SidebarElementType[];
};

export const SidebarAccordionSection = ({ title, elements }: Props) => (
  <Accordion
    defaultExpanded={true}
    disableGutters
    sx={{
      boxShadow: 'none',
      '&:before': {
        display: 'none',
      },
    }}
  >
    <AccordionSummary expandIcon={<ArrowDownIcon />} data-sm="accordion-summary">
      <Typography fontSize={14} fontWeight={700}>
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
        {elements?.map((element) => (
          <AccordionDetailtem
            key={element.id}
            icon={element.icon}
            name={element.name}
            type={element.type}
            drawerType={element.drawerType}
            testId={element.testId}
          />
        ))}
      </Box>
    </AccordionDetails>
  </Accordion>
);
